var scope_0 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/17bac20fa3725117c9909b1fb3ae75cd.js').default;
var scope_1 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d612131a9b57f30fdde6810079593b77.js').default;
var scope_2 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    